import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var roleListRes;
export const roleListTodo = createAsyncThunk('roleList', async (username) => {
    // let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'user_role_list',
            data: {
                "vemp_name": username
            },
            headers: { "Content-Type": "application/json" }
        })
        return roleListRes = res.data
    } catch (error) {
        return roleListRes = error.response.data
    }
})


const roleListSlice = createSlice({
    name: 'roleList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(roleListTodo.fulfilled, (state, action) => {
            // if (action.payload.success) {
            state.data = action.payload;
            // console.log('roleList', state.data)
            // }
        });
        builder.addCase(roleListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default roleListSlice.reducer; 